import { Form, Input, InputNumber, message, Modal, Radio, Select } from "antd";
import { forwardRef, useImperativeHandle, useState } from "react";

import { createUser, editUser } from "../service";
import { GENDER_DICT, STATUS_DICT } from "../dict";

const ModalCreateUser = forwardRef((props, ref) => {
    const { onReload } = props
    useImperativeHandle(ref, () => ({
        open: handleOnOpen,
    }), [])
    const [open, setOpen] = useState(false)
    const [initInfo, setInitInfo] = useState({ type: 'create' })
    const [form] = Form.useForm()
    const { type } = initInfo

    const handleOnOpen = info => {
        if (info.type === 'edit') {
            form.setFieldsValue({ ...info, phoneRepeat: info.phone })
        }
        setInitInfo(info)
        setOpen(true)
    }

    const handleOnOk = () => {
        form.validateFields().then(values => {
            if (type === 'create') {
                createUser(values).then(res => {
                    if (res.code === 200) {
                        message.success('创建成功')
                        onReload()
                        handleOnCancel()
                    }
                })
            } else {
                editUser({ ...initInfo, ...values }).then(res => {
                    if (res.code === 200) {
                        message.success('更新成功')
                        onReload()
                        handleOnCancel()
                    }
                })
            }
        }).catch(e => {
            message.error('请先将页面信息补充完整')
        })
    }

    const handleOnCancel = () => {
        setOpen(false)
        setInitInfo({ type: 'create' })
        form.resetFields()
    }

    return <Modal
        open={open}
        title={type === 'edit' ? '编辑用户' : '新建用户'}
        onOk={handleOnOk}
        onCancel={handleOnCancel}
        width={600}
    >
        <Form
            form={form}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
        >
            <Form.Item
                label='用户名称'
                name="nickName"
            >
                <Input autoComplete="off" placeholder="请输入用户名称" />
            </Form.Item>
            <Form.Item
                label='请输入手机号'
                name="phone"
                validateTrigger="onBlur"
                rules={[{
                    required: true,
                    message: '手机号码格式不正确',
                    type: 'string',
                    len: 11,
                    pattern: /^1[3-9][0-9]{9}$/
                }]}
            >
                <Input autoComplete="off" placeholder="请输入手机号码" />
            </Form.Item>
            <Form.Item
                label='请再次输入手机号'
                name="phoneRepeat"
                validateTrigger="onBlur"
                rules={[
                    {
                        required: true,
                        message: '手机号码格式不正确',
                        type: 'string',
                        len: 11,
                        pattern: /^1[3-9][0-9]{9}$/
                    },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!value || getFieldValue('phone') === value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(new Error('两次输入的手机号不一致'));
                        },
                    }),
                ]}
            >
                <Input autoComplete="off" placeholder="为了确保准确性，请再输入一次手机号" />
            </Form.Item>

            {type === 'edit' && <>
                <Form.Item
                    label='用户状态'
                    name="status"
                >
                    <Radio.Group options={STATUS_DICT} />
                </Form.Item>
                <Form.Item
                    label='用户年龄'
                    name="age"
                >
                    <InputNumber
                        min={0}
                        precision={0}
                    />
                </Form.Item>
                <Form.Item
                    label='用户性别'
                    name="gender"
                >
                    <Radio.Group options={GENDER_DICT} />
                </Form.Item>
                <Form.Item
                    label='身高(单位:cm)'
                    name="height"
                >
                    <InputNumber
                        stringMode
                        min={0}
                        step={0.5}
                        precision={1}
                    />
                </Form.Item>
                <Form.Item
                    label='体重(单位:kg)'
                    name="weight"
                >
                    <InputNumber
                        stringMode
                        min={0}
                        step={0.5}
                        precision={1}
                    />
                </Form.Item>
                <Form.Item
                    label='基础疾病'
                    name="desc"
                >
                    <Input.TextArea
                        rows={3}
                        placeholder="请简单描述基础疾病，限制100字以内"
                        showCount
                        maxLength={100}
                    />
                </Form.Item>
            </>}

        </Form>
    </Modal>
})

export default ModalCreateUser
